import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'edu_liyou_coupon',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '优惠券',
        addFunName: 'eduLiyouCouponAdd',
        modifyFunName: 'eduLiyouCouponModify',
        delFunName: 'eduLiyouCouponDel',
        queryFunName: 'eduLiyouCouponQueryJoinAmount',
        detailFunName: 'eduLiyouCouponDetail',
        onlineFunName: 'eduLiyouCouponOnline',
        unOnlineFunName: 'eduLiyouCouponUnOnline'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        name: null,
        discountCost: null,
        useCost: null,
        validityDays: null,
        image: null,
        onlineState: null
      },
      rules: {
        name: [{
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }],
        discountCost: [{
          required: true,
          message: '优惠金额不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '优惠金额必须为有效金额',
          trigger: 'blur'
        }],
        useCost: [{
          required: true,
          message: '使用限额不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '使用限额必须为有效金额',
          trigger: 'blur'
        }],
        validityDays: [{
          required: true,
          message: '有效天数不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '有效天数必须为正整数',
          trigger: 'blur'
        }]
        // , image: [
        //   { required: true, message: '优惠券图片不能为空', trigger: 'blur' }
        // ]
        ,
        onlineState: [{
          required: true,
          message: '上架状态不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'online':
          // 上架
          this.online(command.row.id);
          break;
        case 'unOnline':
          // 下架
          this.unOnline(command.row.id);
          break;
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'receive':
          // 领取数据
          this.goChild(command.row, 'receive');
          break;
        case 'use':
          // 使用数据
          this.goChild(command.row, 'use');
          break;
      }
    },
    goChild: function goChild(course, tableName) {
      this.$emit('child-go', course, tableName);
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      paramData.useCost = (paramData.useCost || 0) / 100 || 0;
      paramData.discountCost = (paramData.discountCost || 0) / 100 || 0;
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      saveFormData.useCost = (saveFormData.useCost || 0) * 100 || 0;
      saveFormData.discountCost = (saveFormData.discountCost || 0) * 100 || 0;
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadImage: function uploadImage(_ref) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this.formData.image = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    removeImage: function removeImage() {
      this.formData.image = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this2 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this2.initFormData(res.data);
        _this2.editDialogTitle = _this2.pageConfig.editPageName + '维护';
        _this2.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    },
    unOnline: function unOnline(id) {
      var _this4 = this;
      this.$api[this.pageConfig.unOnlineFunName](id).then(function (res) {
        if (res.data) {
          _this4.$message.success('下架成功');
          _this4.query();
        } else {
          _this4.$message.error('下架失败');
        }
      });
    },
    online: function online(id) {
      var _this5 = this;
      this.$api[this.pageConfig.onlineFunName](id).then(function (res) {
        if (res.data) {
          _this5.$message.success('上架成功');
          _this5.query();
        } else {
          _this5.$message.error('上架失败');
        }
      });
    },
    query: function query() {
      var _this6 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this6.tableData = res.data || [];
        _this6.totalCount = res.count;
        _this6.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this7 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this7.formData.id) {
            _this7.$api[_this7.pageConfig.modifyFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('编辑成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('编辑失败');
              }
            });
          } else {
            _this7.$api[_this7.pageConfig.addFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('新增成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};